const albums = () => {
  fetch('./albumList.json')
  .then((response) => response.json())
  .then((data) => {
    return data
  })
}

export default albums